import { capitalize } from '@/domain/common/format'
import { getPositionLabel } from '@/domain/euler/positions/usePositionName'
import { usePositionNames } from '@/domain/state'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useAccount } from 'wagmi'

interface EulerPositionListItemProps {
  token: Token
  value: NormalizedUnitNumber
  type: 'deposit' | 'borrow'
  vaultName?: string
  marketName?: string
  subAccountId?: number
}

export function EulerPositionListItem({
  token,
  value,
  type,
  vaultName,
  marketName,
  subAccountId,
}: EulerPositionListItemProps) {
  const { address } = useAccount()
  const { getPositionName } = usePositionNames()
  // Use market name if available (e.g., "HypurrFi Prime Market"), then vaultName, otherwise "{symbol} Market"
  const displayName = marketName ? `${marketName} Market` : vaultName || `${token.symbol} Market`
  const subAccountLabel =
    subAccountId !== undefined && subAccountId > 0
      ? getPositionLabel(subAccountId, getPositionName(address, subAccountId))
      : ''

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        <TokenIcon token={token} className="w-8" />
        <div>
          <Typography variant="p" className="text-sm">
            {displayName}
            {subAccountLabel && <span className="ml-2 text-muted-foreground text-xs">{subAccountLabel}</span>}
          </Typography>

          <Typography variant="p" className="text-muted-foreground text-xs">
            {token.format(value, { style: 'compact' })} {token.symbol}
          </Typography>
        </div>
      </div>

      <div className="text-right">
        <Typography variant="p" className="text-sm">
          {type === 'deposit' ? '+' : '-'} {token.formatUSD(value)}
        </Typography>
        <Typography variant="p" className="text-muted-foreground text-xs">
          {capitalize(type)}
        </Typography>
      </div>
    </div>
  )
}
